var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-aside',{staticClass:"z-aside",class:[_vm.collapsed && 'z-sider--collapsed'],attrs:{"width":_vm.realWidth}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }